import swapArrows from 'assets/img/oauth-authorization/img/swap-arrows.svg';
import buenbitLogo from 'assets/img/oauth-authorization/img/buenbit-logo-blue.svg';
import unableToAuthorize from 'assets/img/oauth-authorization/img/errors/unable-to-authorize.svg';

export const images = {
    "buenbit-logo-blue": buenbitLogo,
    "swap-arrows": swapArrows,
    "unable-to-authorize": unableToAuthorize,
};
